(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ============================================================
     STICKY HEADER — scroll behaviour
     ============================================================ */

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      // Browsers can restore the page at an existing scroll position before the
      // first scroll event. Set the visual state immediately in that case.
      if (window.pageYOffset || document.documentElement.scrollTop) {
        this.header.classList.add('scrolled-past-header');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }

      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  /* ============================================================
     DESKTOP DROPDOWN — hover to open, delayed close
     ============================================================ */

  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 990) return;

    document.querySelectorAll('.header__inline-menu > ul > li').forEach(function (item) {
      var details = item.querySelector('details');
      if (!details) return;

      var closeTimer = null;

      item.addEventListener('mouseenter', function () {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        details.setAttribute('open', '');
      });

      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
          closeTimer = null;
        }, 150);
      });
    });
  });


  /* ============================================================
     MOBILE ACCORDION — click to expand + arrow rotate
     ============================================================ */

  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 990) return;

    document.querySelectorAll('#menu-drawer details').forEach(function (details) {
      const summary = details.querySelector('summary');
      const icon    = summary && summary.querySelector('.icon-triangle-down');
      if (!summary || !icon) return;

      details.addEventListener('toggle', function () {
        icon.style.transform = details.hasAttribute('open')
          ? 'rotate(180deg)'
          : 'rotate(0deg)';
      });

      if (!details.hasAttribute('open')) {
        icon.style.transform = 'rotate(0deg)';
      }
    });
  });

/* ============================================================
   PARENT MENU ACTIVE STATE - SHOW BOTH PARENT & CHILD
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 990) return;

  var currentPath = window.location.pathname.replace(/\/$/, '');

  // Remove all existing active classes
  document.querySelectorAll('.header__active-menu-item').forEach(function(el) {
    el.classList.remove('header__active-menu-item');
  });

  document.querySelectorAll('.list-menu__item--active').forEach(function(el) {
    el.classList.remove('list-menu__item--active');
  });

  document.querySelectorAll('.active-direct-link').forEach(function(el) {
    el.classList.remove('active-direct-link');
  });

  document.querySelectorAll('.has-active-child').forEach(function(el) {
    el.classList.remove('has-active-child');
  });

  document.querySelectorAll('.header__inline-menu > ul > li').forEach(function (li) {
    var details = li.querySelector('details');
    
    if (!details) {
      // Direct link without dropdown - mark as active if matches
      var directLink = li.querySelector('a');
      if (directLink) {
        var href = directLink.getAttribute('href');
        if (href) {
          var linkPath = href.split('?')[0].split('#')[0].replace(/\/$/, '');
          if (linkPath === currentPath) {
            li.classList.add('header__active-menu-item');
            directLink.classList.add('active-direct-link');
          }
        }
      }
      return;
    }

    // Has dropdown - check if any submenu item is active
    var submenuLinks = details.querySelectorAll('.header__submenu a');
    var hasActiveChild = false;
    
    submenuLinks.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;

      var linkPath = href.split('?')[0].split('#')[0].replace(/\/$/, '');

      if (linkPath === currentPath) {
        hasActiveChild = true;
        
        // Mark the submenu link as active
        link.setAttribute('aria-current', 'page');
        link.classList.add('active-submenu-link');
        link.parentElement.classList.add('list-menu__item--active');
      }
    });

    // Mark parent dropdown as active if any child is active
    if (hasActiveChild) {
      li.classList.add('header__active-menu-item');
      li.classList.add('has-active-child');
      
      // Mark the parent summary as well
      var summary = details.querySelector('summary');
      if (summary) {
        summary.classList.add('parent-has-active-child');
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
